export default {
  home: {
    minute: "minut",
    hour: "sat",
    days: "dani",
    price_info: "Prvih {mianfei} minuta je besplatno. Maksimalna cijena za 24 sata iznosi {fengding} {currencyName}. Vaš depozit od {yajin} {currencyName} biće automatski vraćen nakon što vratite punjač.",
    feature_1: "Uključuje sve vrste kablova: iPhone, Type-C i Micro-USB",
    feature_2: "Može se vratiti na bilo koju stanicu",
    feature_3: "Dostupno bežično punjenje",
    tips_1: "Vaš depozit od {currencyName}{yajin} biće vraćen na kraju iznajmljivanja",
    tips_2: "Depozit za dopunu {currencyName}{yajin} može se koristiti za iznajmljivanje i može se vratiti nakon što se iskoristi",
    tips_3: "Trenutni saldo je {currencyName}{myyue}, i može se koristiti direktno za iznajmljivanje",
    submit: "Započnite iznajmljivanje",
    borrow: "Iznajmi",
    msg_fail_title: "Greška",
    msg_fail_content: "Iznajmljivanje nije uspjelo, molimo pokušajte ponovo",
    msg_rentcount: "Trenutno imate {zujieNum} narudžbi koje nisu zatvorene",
    goborrow: "Idite na punjenje!!!",
    nearby: "Pogledajte obližnje stanice",
    preauth: "Prethodna autorizacija"
  },
  login: {
    code_title: "Verifikacija putem SMS-a",
    phone_number: "Broj telefona",
    verification_code: "Molimo unesite verifikacioni kod iz SMS-a",
    captcha_code: "Kod",
    send_code: "Pošalji kod",
    login: "Prijava",
    agree: "Klikom na Prijavi se, slažete se sa",
    readme: "Korisničkim sporazumom",
    msg_fail_login: "Prijava nije uspjela",
    msg_success_login: "Prijava uspješna",
    msg_fail_user: "Greška pri dobijanju korisničkih podataka. Želite li pokušati ponovo?",
    sign_in_with: "Prijavite se pomoću",
    no_sms: "Niste primili tekstualnu poruku",
    retry: "Ponovo pošaljite"
  },
  confirm: {
    deletecard: "Obrišite karticu",
    addcard: "Unesite podatke o kartici",
    title: "Potvrda plaćanja",
    paynow: "Odmah platite",
    SMSConfirm: "Molimo platite prema tekstualnoj poruci primljenoj na vaš telefon i kliknite na dugme Potvrdi da nastavite.",
    pay_label: "Iznos",
    auth_label: "Prethodna autorizacija",
    price_tips: "Vaš saldo može biti povučen na zahtjev. Može potrajati 1-5 radnih dana da se pojavi na vašem računu za plaćanje.",
    auth_tips: "Obavezan je iznos prethodne autorizacije od {0}{1}. Stvarni iznos za iznajmljivanje biće odbijen kada punjač bude vraćen.",
    pay_type: "Molimo odaberite željeni način plaćanja",
    submit: "Potvrdite uplatu",
    msg_loading: "Učitavanje...",
    msg_fail_title: "Upozorenje",
    msg_fail_payment: "Nije uspjelo pokretanje plaćanja depozita",
    msg_fail_order: "Nije uspjelo kreiranje narudžbe za iznajmljivanje",
    msg_fail_support: "Sistem nije podržan",
    msg_fail_confirm: "Potvrdi",
    msg_fail_retry: "Pokušaj ponovo",
    msg_fail_cancel: "Otkaži",
    bill: "Račun",
    postal_code: "Poštanski broj",
    city: "Grad",
    address: "Adresa",
    email: "E-mail",
    bill_tips: "Molimo unesite podatke za naplatu"
  },
  mine: {
    title: "Korisnički profil",
    wallet: "Moj novčanik",
    balance: "Moj saldo",
    deposit: "Depozit",
    wallet_in: "Napunite",
    wallet_out: "Podignite",
    wallet_log: "Evidencija novčanika",
    rental_history: "Istorija iznajmljivanja",
    payment_title: "Metode plaćanja",
    download_app: "Preuzmite aplikaciju",
    settings: "Postavke",
    help: "Pomoć",
    logout: "Odjavite se",
    login_tips: "Molimo prijavite se",
    msg_fail_title: "Greška",
    msg_fail_update: "Izmjena nije uspjela. Molimo pokušajte ponovo",
    msg_loading: "Učitavanje...",
    msg_fail_user: "Greška pri dobijanju korisničkih podataka. Želite li pokušati ponovo?",
    edit_profile: "Uredite profil",
    join_us: "PRIDRUŽITE NAM SE",
    join_us_details: "Nabavite PocketPower stanicu na svojoj lokaciji"
  },
  msg: {
    appoffline: "Aplikacija još nije pokrenuta, molimo sačekajte",
    deletecard: "Jeste li sigurni da želite obrisati ovu karticu?",
    no_phone: "Broj telefona je obavezan",
    loading: "Učitavanje...",
    title: "Savjet",
    success: "Operacija uspješna",
    error: "Nepoznata greška. Molimo pokušajte ponovo kasnije",
    roleerror: "Nedovoljne dozvole. Molimo obratite se administratoru.",
    neterror: "Povezivanje s mrežom nije uspjelo. Molimo pokušajte ponovo kasnije",
    confirm: "Potvrdi",
    retry: "Pokušaj ponovo",
    cancel: "Otkaži",
    title_fail: "Upozorenje",
    vieworder: "Pogledajte narudžbu",
    success_payment: "Plaćanje završeno",
    success_buy: "Kupovina završena",
    fail_payment: "Plaćanje nije uspjelo",
    keyword: "Ključna riječ",
    ispayorder: "Molimo potvrdite da li je plaćanje izvršeno",
    unpay: "Neplaćeno",
    yespay: "Plaćeno",
    notopen: "Još nije otvoreno"
  },
  result: {
    tips: "Da biste pogledali narudžbe i druge lokacije stanica, molimo preuzmite aplikaciju.",
    download: "Preuzmite aplikaciju",
    title: "Iznajmljivanje potvrđeno",
    gotit: "Razumijem",
    price_plan: "Standard naplate",
    msg_success: "Uspješno iznajmljeno",
    msg_tips_loading: "Punjač se izbacuje, molimo sačekajte...",
    msg_result_loading: "Rezultat plaćanja se potvrđuje...",
    msg_fail_confirm: "Potvrdi",
    btn_usage: "Napomena o korištenju",
    btn_return: "Napomena o vraćanju",
    deposit: "Depozit",
    msg_fail_content: "Zahtjev nije uspio. Molimo pokušajte ponovo.",
    price_label: "po satu",
    price_info: "Besplatno za prvih {mianfei} minuta, maksimalna dnevna cijena je {fengding} {ccurrency}. Depozit će automatski biti odbijen kada iznos iznajmljivanja dostigne {yajin} {ccurrency}.",
    tips_1: "Molimo preuzmite punjač broj {number} kako je prikazano na slici",
    tips_2: "Organizujte kablove i ubacite punjač u slot sa stranom označenom sa [strelice prema dolje]",
    msg_note_usage: "Punjač je opremljen sa 3 vrste kablova, molimo odaberite onaj koji vam je potreban za uređaj.",
    msg_note_return: "Organizujte kablove i ubacite punjač u slot sa stranom označenom sa [strelice prema dolje]",
    return_info: "Prilikom vraćanja, osigurajte da su kablovi uredno složeni i ubacite stranu sa metalnim čipovima u dostupan slot dok ne dostigne dno i stabilizuje se.",
    download_tips: "Da biste iznajmili naš punjač, možete odabrati jednu od sljedećih opcija"
  },
  result_msg: {
    loading: "Učitavanje...",
    refresh: "Osvježi"
  },
  order: {
    title: "Istorija iznajmljivanja",
    in_use: "U upotrebi",
    ended: "Završeno",
    msg_error: "Zahtjev nije uspio",
    order_number: "Broj",
    order_details: "Detalji narudžbe",
    order_zj_shop: "Lokacija iznajmljivanja",
    order_zj_time: "Vrijeme iznajmljivanja",
    order_gh_shop: "Lokacija vraćanja",
    order_gh_time: "Vrijeme vraćanja",
    order_use_time: "Broj korištenja",
    order_amount: "Ukupni iznos",
    not_on_rent: "Nije iznajmljeno",
    "renting": "U iznajmljivanju",
    "undone": "Poništeno",
    "returned": "Vraćeno",
    "questions": "Pitanja",
    "timeout_to_return": "Isteklo vrijeme za vraćanje",
    "suspended_for_billing": "Obustavljeno zbog naplate"
  },
  order_item: {
    order_number: "Broj",
    venue_rented: "Lokacija preuzimanja",
    time_rented: "Vrijeme preuzimanja",
    venue_returned: "Lokacija vraćanja",
    time_returned: "Vrijeme vraćanja",
    charge_standard: "Standard naplate",
    charge_standard_info: "{pJifei} {pCurrency} po satu (prvih {pMian} minuta besplatno)",
    rent_occurred: "Došlo je do iznajmljivanja",
    returned: "Vraćeno",
    unreturned: "Nije vraćeno",
    type_0: "Nije dovršeno",
    type_1: "U iznajmljivanju",
    type_2: "Otkazano",
    type_3: "Vraćeno",
    type_4: "Došlo je do greške",
    type_5: "Prekoračeno vrijeme",
    min: "Min",
    payment: "Plaćanje"
  },
  setting: {
    title: "Postavke",
    lang: "Jezik"
  },
  help: {
    title: "Često postavljana pitanja",
    rentals: "Iznajmljivanja",
    venues: "Lokacije",
    payments: "Plaćanja"
  },
  wallet_in: {
    title: "Dopuna salda",
    price_label: "Iznos za dopunu",
    price_placeholder: "Molimo unesite iznos za dopunu",
    balance: "Trenutni saldo",
    price_auto: "Izaberite iznos plaćanja",
    price_tips: "Vaš saldo može biti povučen na zahtjev. Može potrajati 1-5 radnih dana da se pojavi na vašem računu.",
    submit: "Pošalji",
    loading: "Učitavanje...",
    paying: "Preusmjeravanje na stranicu za plaćanje...",
    msg_title: "Savjeti",
    msg_fail_order: "Nije uspjelo kreiranje narudžbe za dopunu",
    msg_fail_payment: "Nije uspjelo pokretanje plaćanja za dopunu",
    msg_fail_retry: "Pokušaj ponovo"
  },
  wallet_out: {
    title: "Povlačenje",
    price_label: "Iznos za povlačenje",
    price_placeholder: "Molimo unesite iznos za povlačenje",
    balance: "Trenutni saldo",
    balance_all: "Povuci sve",
    deposit: "Depozit",
    deposit_tips: "Postoji neizmirena narudžba za iznajmljivanje. Depozit od Ksh{pyajin} nije povratan",
    submit: "Pošalji",
    apply: "Primijeni",
    confirm: "Potvrdi",
    loading: "Učitavanje...",
    msg_fail_price: "Iznos za povlačenje je netačan",
    msg_fail_balance: "Iznos za povlačenje ne može premašiti trenutni saldo",
    msg_fail_submit: "Molimo unesite sve potrebne podatke",
    msg_title: "Greška",
    msg_success_content: "Povrat uspješan",
    confirmtitle: "Savjeti",
    confirmcontent: "Trenutni novčanik ne podržava povlačenje gotovine. Molimo unesite kontakt podatke za ručnu obradu povrata",
    payee_name: "Ime primaoca",
    payee_bankcard: "Broj bankovne kartice",
    payee_phone: "Telefon",
    cancelText: "Otkaži",
    confirmText: "Ponovo prijavi"
  },
  map: {
    在线: "Otvori",
    离线: "Zatvori",
    title: "Najbliža stanica",
    result_msg: "Nije pronađena nijedna stanica u blizini",
    msg_title: "Greška",
    no_support: "Izvinjavamo se! Vaš pregledač ne podržava usluge lokacije",
    my_position: "Moja lokacija",
    distance: "Udaljenost:",
    shop_time: "Radno vrijeme",
    free: "Dostupno za iznajmljivanje",
    return: "Dostupna prazna mjesta",
    shop_title: "Detalji lokacije",
    address: "Adresa",
    go_here: "Idi ovdje",
    nav_help: "Pomoć",
    nav_search: "Pretraga"
  },
  scanQr: {
    NotAllowedError: "Potrebno je omogućiti pristup kameri",
    NotFoundError: "Na ovom uređaju nema kamere",
    NotSupportedError: "Potreban sigurnosni kontekst (HTTPS, localhost)",
    NotReadableError: "Kamera je u upotrebi",
    OverconstrainedError: "Instalacija kamere nije odgovarajuća",
    StreamApiNotSupportedError: "Ovaj pregledač ne podržava streaming API"
  },
  payment: {
    payment_title: "Metode plaćanja",
    pay_type: "Molimo unesite podatke o kartici",
    add_payment_card: "Dodajte karticu za plaćanje",
    add_payment: "Dodaj plaćanje"
  },
  shop: {
    title: "Najbliža stanica",
    search_station: "Pretraži stanicu",
    search_station_tips: "Molimo unesite ime stanice",
    shop_power_banks: "Punjači",
    shop_empty_slots: "Prazna mjesta",
    shop_address: "Adresa",
    shop_business_hours: "Radno vrijeme",
    shop_directions_station: "Dobijte upute do stanice",
    shop_scan_qrcode: "Skenirajte QR kod"
  }
};
